import { ConsultationPrompt } from ".";

export default function ConsultationPromptExamples() {
  function onContinueButtonClick() {
    console.log("Continue button clicked");
  }

  function onBackButtonClick() {
    console.log("Back button clicked");
  }

  function onFindADoctorButtonClick() {
    console.log("More info button clicked");
  }

  return (
    <>
      <ConsultationPrompt
        onContinueButtonClick={onContinueButtonClick}
        onBackButtonClick={onBackButtonClick}
        onFindADoctorButtonClick={onFindADoctorButtonClick}
      />

      <ConsultationPrompt
        onContinueButtonClick={onContinueButtonClick}
        onBackButtonClick={onBackButtonClick}
        onFindADoctorButtonClick={onFindADoctorButtonClick}
        consultationType="NurseConsult"
      />
    </>
  );
}
